import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Formats a YYYY-MM-DD string as DD/MM/YYYY (es-MX). Returns '' when invalid.
const formatStartDate = (startStr) => {
  if (!startStr) return '';
  const d = new Date(`${startStr}T00:00:00`);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

// Returns the list of parcial indices (1..3) whose reminder is currently active.
// A reminder i is active when:
//   - Control Escolar defined a start date for parcial i, AND
//   - today >= (start_i - 3 days), AND
//   - the section has fewer than i separators inserted.
export function getDueParcialReminders(partialDates, separatorCount) {
  if (!partialDates) return [];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = [];
  for (let i = 1; i <= 3; i++) {
    const startStr = partialDates[`parcial_${i}_start`];
    if (!startStr) continue;
    const start = new Date(`${startStr}T00:00:00`);
    if (isNaN(start.getTime())) continue;
    const trigger = new Date(start);
    trigger.setDate(trigger.getDate() - 3);
    if (today >= trigger && (separatorCount || 0) < i) {
      due.push(i);
    }
  }
  return due;
}

// Stacked reminder banners for a single teacher section (Asistencias, Tareas, etc.).
export const PartialReminderBanner = ({ partialDates, separatorCount, sectionLabel }) => {
  const due = getDueParcialReminders(partialDates, separatorCount);
  if (due.length === 0) return null;

  return (
    <div className="space-y-2 mb-4" data-testid="partial-reminder-banners">
      {due.map((i) => {
        const startDate = formatStartDate(partialDates?.[`parcial_${i}_start`]);
        return (
          <div
            key={i}
            data-testid={`partial-reminder-${i}`}
            className="flex items-start gap-3 rounded-lg border-l-4 border-amber-500 bg-amber-50 px-4 py-3 shadow-sm"
          >
            <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 shrink-0" />
            <p className="text-sm text-amber-900">
              <strong>Recordatorio importante:</strong> ya se acerca la fecha para cargar las
              calificaciones del <strong>Parcial {i}</strong>
              {startDate && (
                <> (a partir del <strong data-testid={`partial-reminder-${i}-date`}>{startDate}</strong>)</>
              )}
              . Recuerda cerrar el <strong>Parcial {i}</strong> insertando el separador correspondiente
              en <strong>{sectionLabel}</strong>. La aplicación necesita el separador para calcular
              correctamente este parcial.
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default PartialReminderBanner;
